import { CommonModule } from '@angular/common';
import {
  Component,
  computed,
  effect,
  ElementRef,
  inject,
  model,
  OnInit,
  output,
  signal,
  viewChild,
} from '@angular/core';
import { TranslocoModule, TranslocoService } from '@jsverse/transloco';
import QRCodeStyling from 'styled-qr-code';
import { OrgService } from '../../../../shared/services/org.service';
import {
  AccountTypeCode,
  PaymentAccount,
} from '../../../../shared/schemas/payment_account';
import { environment } from '../../../../../environments/environment';
import { Share } from '@capacitor/share';
import { DeviceService } from '../../../../shared/services/device.service';
import { Filesystem, Directory, Encoding } from '@capacitor/filesystem';
import { Capacitor } from '@capacitor/core';

@Component({
  selector: 'qwiko-qr-code',
  imports: [CommonModule, TranslocoModule],
  templateUrl: './qr-code.component.html',
  styleUrl: './qr-code.component.scss',
})
export class QrCodeComponent implements OnInit {
  orgService = inject(OrgService);
  translocoService = inject(TranslocoService);
  deviceService = inject(DeviceService);

  canvas = viewChild<ElementRef<HTMLDivElement>>('canvas');
  selectedPaymentAccount = model<PaymentAccount | null>();
  qr: any;

  copying = signal<boolean>(false);
  hasCopied = output<boolean>();
  hasShared = output<boolean>();
  canDownload = model<boolean>(true);
  canCopy = model<boolean>(true);
  canShare = model<boolean>(true);
  hasOfflineToggle = model<boolean>(false);
  amount = model<number | null>(0);
  paymentCode = model<string | null>(null);
  ussdAmount = computed(() => {
    if (this.amount() === null || this.amount() === 0) {
      return 0;
    }

    // let number: string | number = this.amount()!;

    // number = number.replace(/[\s,]/g, '');
    // number = number.replace(/[^0-9,]/g, '');

    return this.amount();
  });
  isOffLineMode = model<boolean>(false);
  addPaymentAccount = output<boolean>();
  trigger = computed<string>(() => {
    let number = '0';
    if (this.isOffLineMode()) {
      number = this.selectedPaymentAccount()?.number_display || '0';
    } else {
      number = this.selectedPaymentAccount()?.number || '0';
    }
    const amount = this.ussdAmount()?.toString() || '0';
    const trigger = this.ussd()
      .replace(':number', number)
      .replace(':code', number)
      .replace(':amount', amount);

    return trigger;
  });

  ussd = computed<string>(() => {
    if (this.isOffLineMode() || this.selectedPaymentAccount()) {
      const paymentProvider = this.selectedPaymentAccount()?.payment_provider;
      const ussds_to = paymentProvider?.ussds_to;

      const ussd = ussds_to?.find((ussd) => {
        const hasService = ussd.service?.code === 'SEND_MONEY';
        const hasFromAccountType = ussd.from_account_type?.code === 'MOMO';
        const hasToProvider = ussd.to_provider?.code === paymentProvider?.code;

        if (hasService && hasFromAccountType && hasToProvider) {
          return ussd;
        }

        return null;
      });

      if (ussd) {
        return ussd.ussd_code!;
      }

      return '';
    }
    return '';
  });

  paymentLink = computed(() => {
    if (this.isOffLineMode()) {
      return this.offlinePaymentLink();
    } else {
      return `${environment.qrUrl}/?t=${this.paymentCode()}`;
    }
    // if (this.paymentCode()) {
    //   return `${environment.qrUrl}/?t=${this.paymentCode()}`;
    // }
    // if (this.selectedPaymentAccount()) {
    //   let link: string = '';
    //   if (this.isOffLineMode()) {
    //     return this.offlinePaymentLink();
    //   }

    //   link = `${environment.qrUrl}/?a=${this.selectedPaymentAccount()?.code}`;
    //   if (this.ussdAmount()) {
    //     link = `${environment.qrUrl}/?a=${this.selectedPaymentAccount()?.code}&am=${this.ussdAmount()}`;
    //   }
    //   return link;
    // } else if (this.orgService.org()?.code) {
    //   let link: string = '';
    //   if (this.isOffLineMode()) {
    //     return this.offlinePaymentLink();
    //   }
    //   link = `${environment.qrUrl}/?b=${this.orgService.org()?.code}`;
    //   if (this.ussdAmount()) {
    //     link = `${environment.qrUrl}/?b=${this.orgService.org()?.code}&am=${this.ussdAmount()}`;
    //   }
    //   return link;
    // } else {
    //   return null;
    // }
  });

  link = model<string>('');
  loading = signal<boolean>(false);
  loadingEffect = effect(() => {
    if (!this.loading()) {
      this.loadingTarget.set(null);
    }
  });
  loadingTarget = signal<string | null>(null);

  constructor() {
    effect(() => {
      if (this.link() || this.paymentLink()) {
        if (this.canvas() && this.canvas()?.nativeElement) {
          this.canvas()!.nativeElement.innerHTML = '';
          this.generateQrCode();
        }
      } else {
      }
    });
  }

  ngOnInit(): void {
    this.generateQrCode();
  }

  toggleOffLineMode(event: any) {
    event.preventDefault();
    if (this.selectedPaymentAccount() == null) {
      this.addPaymentAccount.emit(true);
      return;
    }
    this.isOffLineMode.set(!this.isOffLineMode());
  }

  offlinePaymentLink(): string | null {
    // console.log('offlinePaymentLink', this.isOffLineMode());
    // if (this.selectedPaymentAccount() == null) {
    //   this.addPaymentAccount.emit(true);
    //   return null;
    // }

    return `tel://${this.trigger()}`;
  }

  copy() {
    this.copying.set(true);
    this.hasCopied.emit(true);
    setTimeout(() => this.copying.set(false), 2000);
    const value = this.translocoService.translate('share_text', {
      org_name: this.orgService.org()?.name,
    });
    const share_text = `${value}\n\n${this.link() || this.paymentLink()}`;
    navigator.clipboard.writeText(share_text).then(() => {});
  }

  async share() {
    this.loading.set(true);
    this.loadingTarget.set('share');
    this.hasShared.emit(true);
    const value = this.translocoService.translate('share_text', {
      org_name: this.orgService.org()?.name,
    });
    const share_text = `${value}\n\n${this.link() || this.paymentLink()}`;
    const shareData = {
      text: share_text,
      // url: this.link() || this.paymentLink() || '',
    };
    // console.trace('shareData', shareData);
    try {
      await Share.share(shareData);
      this.loading.set(false);
    } catch (error) {
      this.loading.set(false);
    }
  }

  generateQrCode() {
    if (this.link() || this.paymentLink()) {
      this.qr = new QRCodeStyling({
        width: 300,
        height: 300,
        type: 'svg',
        data: this.link() || this.paymentLink() || '',
        image: './assets/logo/qwikopay-icon-sqr-dark.svg',
        margin: 5,
        qrOptions: {
          typeNumber: 0,
          mode: 'Byte',
          errorCorrectionLevel: 'H',
        },
        imageOptions: {
          imageSize: 0.3,
          hideBackgroundDots: true,
          margin: 5,
          crossOrigin: 'anonymous',
        },
        dotsOptions: {
          color: '#5100AE',
          type: 'classy',
        },
        backgroundOptions: {
          color: '#ffffff',
        },
        cornersSquareOptions: {
          color: '#5100AE',
          type: 'extra-rounded',
        },
        cornersDotOptions: {
          color: '#5100AE',
          type: 'dot',
        },
      });

      this.qr.append(this.canvas()?.nativeElement);
      setTimeout(() => {
        this.qr;
        // this.qr.innerHTML += '<span class=""> QwikoPay </span>';
      }, 3000);
    }
  }

  async download() {
    try {
      this.loading.set(true);
      this.loadingTarget.set('download');

      // Retrieve the QR code as a PNG data URL
      // const dataUrl = await this.qr.getRawData('png');
      const dataUrl = await this.qr.getRawData('png'); // returns Blob

      const base64DataUrl = await this.blobToBase64(dataUrl); // convert to base64 string
      const base64Data = base64DataUrl.split(',')[1]; // remove "data:image/png;base64,"

      // Web: Directly download using an anchor element
      if (Capacitor.getPlatform() === 'web') {
        const link = document.createElement('a');
        link.href = base64DataUrl;
        link.download = this.orgService.org()?.name + '@qwiko' + '.png';
        link.click();
      } else {
        // Mobile (iOS/Android): Convert data URL to Base64 string
        // const base64Data = dataUrl.split(',')[1];
        const fileName = this.orgService.org()?.name + '@qwiko' + '.png';

        // Write file to device storage (Documents directory used here)
        await Filesystem.writeFile({
          path: fileName,
          data: base64Data,
          directory: Directory.Documents,
        });

        // Retrieve file URI to share
        const fileUri = await Filesystem.getUri({
          directory: Directory.Documents,
          path: fileName,
        });

        // Open native share dialog for saving or sharing the QR code
        await Share.share({
          url: fileUri.uri,
        });
      }
      this.loading.set(false);
    } catch (error) {
      console.error('Error downloading QR code:', error);
      this.loading.set(false);
    }
  }

  blobToBase64(blob: Blob): Promise<string> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onerror = reject;
      reader.onload = () => {
        resolve(reader.result as string);
      };
      reader.readAsDataURL(blob);
    });
  }

  // async download() {
  //   const extension = 'png';
  //   const fileName = this.orgService.org()?.name + '@qwiko';
  //   const blob = await this.qr.getRawData(extension);
  //   const base64 = (await this.blobToBase64(blob)) as string;
  //   this.loading.set(true);
  //   this.loadingTarget.set('download');

  //   if (this.deviceService.isWeb()) {
  //     this.download4Web(base64, fileName);
  //   } else {
  //     const result = await Filesystem.writeFile({
  //       path: fileName,
  //       data: base64.split(',')[1], // remove base64 header
  //       directory: Directory.Documents,
  //     });

  //     // const value = this.translocoService.translate('share_text', {
  //     //   org_name: this.orgService.org()?.name,
  //     // });
  //     // const share_text = `${value}\n\n${this.link() || this.paymentLink()}`;
  //     const shareData = {
  //       url: `file://${result.uri}`,
  //     };

  //     await Share.share(shareData);
  //   }

  //   // await this.qr.download({
  //   //   name: this.orgService.org()?.name + '@qwiko',
  //   //   extension: 'png',
  //   // });
  //   this.loading.set(false);
  // }

  // private blobToBase64(blob: Blob): Promise<string | ArrayBuffer | null> {
  //   return new Promise((resolve, reject) => {
  //     const reader = new FileReader();
  //     reader.onerror = reject;
  //     reader.onload = () => resolve(reader.result);
  //     reader.readAsDataURL(blob);
  //   });
  // }

  // private download4Web(base64DataUrl: string, filename: string) {
  //   const link = document.createElement('a');
  //   link.href = base64DataUrl;
  //   link.download = filename;
  //   document.body.appendChild(link);
  //   link.click();
  //   document.body.removeChild(link);
  // }
}
